/**
 * Miansai — Single free shipping threshold behavior
 *
 * When free_shipping_threshold_2 is 0 (2nd Day Air discontinued):
 * - Hide second progress track via CSS classes
 * - Fix unlock logic so Basic Free Shipping does not fall into t2===0 bug
 *
 * NOTE: Avoid MutationObserver attribute loops — that froze the page.
 */
(function () {
  'use strict';

  var applied = false;
  var updating = false;

  function threshold2Disabled() {
    var t2 = Number(window.free_shipping_threshold_2);
    return !t2 || t2 <= 0 || isNaN(t2);
  }

  function applySingleModeClasses() {
    if (!threshold2Disabled()) return false;
    if (applied && document.body.classList.contains('ms-single-fs-threshold')) {
      return true;
    }

    document.documentElement.classList.add('ms-single-fs-threshold');
    document.body.classList.add('ms-single-fs-threshold');

    var drawer = document.getElementById('CartDrawer');
    if (drawer) drawer.classList.add('ms-single-threshold');

    document.querySelectorAll('#CartDrawer .progress-bar-wrapper, .minicart-header .progress-bar-wrapper').forEach(function (el) {
      el.classList.add('ms-single-threshold');
    });

    applied = true;
    return true;
  }

  function money(cents) {
    try {
      if (window.Shopify && typeof Shopify.formatMoney === 'function') {
        return Shopify.formatMoney(cents, window.moneyFormat || '${{amount}}');
      }
    } catch (e) {}
    return '$' + (Number(cents) / 100).toFixed(2);
  }

  function updateSingleThreshold(cartTotalCents) {
    if (!threshold2Disabled() || updating) return;
    updating = true;

    try {
      applySingleModeClasses();

      var rate = 1;
      try {
        if (window.Shopify && Shopify.currency && Shopify.currency.rate) {
          rate = Number(Shopify.currency.rate) || 1;
        }
      } catch (e) {}

      var t1 = Number(window.free_shipping_threshold_1) * 100 * rate;
      if (!t1 || isNaN(t1)) return;

      var total = Number(cartTotalCents);
      if (isNaN(total)) return;

      var msg = document.querySelector('#CartDrawer .free-shipping-thresholds .free-shipping-threshold-1');
      var msgCount = msg && msg.querySelector('.count');
      var success = document.querySelector('#CartDrawer .free-shipping-thresholds .free-shipping-threshold-1-success-message');
      var fill = document.querySelector('#CartDrawer .progress-bar-wrapper .progress-bar-fill.free-shipping-threshold-1');
      var fill2 = document.querySelector('#CartDrawer .progress-bar-wrapper .progress-bar-fill.free-shipping-threshold-2');
      var msg2 = document.querySelector('#CartDrawer .free-shipping-thresholds .free-shipping-threshold-2');
      var success2 = document.querySelector('#CartDrawer .free-shipping-thresholds .free-shipping-threshold-2-success-message');

      if (fill2) {
        fill2.classList.add('hide');
        fill2.style.width = '0%';
      }
      if (msg2) msg2.classList.add('hide');
      if (success2) success2.classList.add('hide');

      if (!fill) return;

      if (total <= 0) {
        fill.style.width = '0%';
        fill.classList.add('hide');
        if (msg) msg.classList.remove('hide');
        if (success) success.classList.add('hide');
        if (msgCount) msgCount.textContent = money(t1);
        return;
      }

      if (total < t1) {
        var pct = Math.max(0, Math.min(100, (total / t1) * 100));
        fill.classList.remove('hide');
        fill.style.width = pct + '%';
        if (msg) msg.classList.remove('hide');
        if (success) success.classList.add('hide');
        if (msgCount) msgCount.textContent = money(t1 - total);
        return;
      }

      fill.classList.remove('hide');
      fill.style.width = '100%';
      if (msg) msg.classList.add('hide');
      if (success) success.classList.remove('hide');
    } finally {
      updating = false;
    }
  }

  function readCartTotalAndUpdate() {
    if (!threshold2Disabled() || updating) return;
    fetch('/cart.js', { credentials: 'same-origin' })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        updateSingleThreshold(cart.total_price);
      })
      .catch(function () {});
  }

  function onCartEvent(e) {
    var total = e && e.detail && e.detail.cart_total_price;
    if (typeof total === 'number') updateSingleThreshold(total);
    else readCartTotalAndUpdate();
  }

  function init() {
    if (!threshold2Disabled()) return;

    applySingleModeClasses();
    readCartTotalAndUpdate();

    window.addEventListener('adjustCartCallback', onCartEvent);
    window.addEventListener('cartUpdateCallback', onCartEvent);

    if (window.jQuery) {
      jQuery(document.body).on('afterCartLoad.ajaxCart.miansaiSingleFs', function () {
        applySingleModeClasses();
        readCartTotalAndUpdate();
      });
    }

    // When bag opens — one delayed refresh only (no MutationObserver)
    document.addEventListener('click', function (e) {
      var opener = e.target && e.target.closest && e.target.closest(
        '.js-drawer-open-right, .site-header__cart-toggle, [aria-controls="CartDrawer"], .block-minicart'
      );
      if (!opener) return;
      window.setTimeout(function () {
        applySingleModeClasses();
        readCartTotalAndUpdate();
      }, 400);
    }, true);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
